const faqItems = [
  {
    q: '春色影视真的完全免费吗？',
    a: '是的，春色影视所有内容完全免费在线观看，无需注册、无需付费、无需会员。我们通过广告合作维持平台运营，确保观众可以零成本享受高清影视体验。不缓冲、不收费是我们的核心承诺。',
  },
  {
    q: '为什么春色影视的播放速度这么快？',
    a: '春色影视采用先进的分布式CDN加速和多线路智能调度技术，自动匹配最优节点。即使在高并发时段也能实现秒开无卡顿播放，这项不缓冲技术是我们平台的核心竞争力。',
  },
  {
    q: '支持哪些设备观看？',
    a: '春色影视支持全平台观看，包括电脑端、平板、手机浏览器。无需下载任何APP，打开网页即可流畅播放。建议使用Chrome、Safari等现代浏览器获得最佳体验，高清画质最高可达1080P。',
  },
  {
    q: '影片更新频率是怎样的？',
    a: '我们保持每日实时更新，电影电视剧全集第一时间同步上线。热门新片通常在首播后数小时内即可观看，综艺和动漫也保持同步更新节奏，确保你不错过任何精彩内容。',
  },
  {
    q: '观看时需要注册账号吗？',
    a: '不需要。春色影视倡导零门槛观影，打开即看。无需注册、无需登录、无需填写任何个人信息。我们认为好的观影体验就应该如此简单直接，这也是秒开体验的一部分。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-400">快速了解春色影视的使用方式</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="group bg-background-200/50 rounded-lg border border-background-300/30 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base text-foreground-200 font-medium list-none">
                <span>{item.q}</span>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-400 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}